import { render, staticRenderFns } from "./GrowthValueRule.vue?vue&type=template&id=9e56ae04"
import script from "./GrowthValueRule.vue?vue&type=script&lang=js"
export * from "./GrowthValueRule.vue?vue&type=script&lang=js"
import style0 from "./GrowthValueRule.vue?vue&type=style&index=0&id=9e56ae04&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports